import type { ButtonSizeType } from '@design-system';
import { isInNextSixDays } from '@utils/product';
import { useTranslation } from 'next-i18next';
import React from 'react';

import {
  getProductRef,
  getProductStatus,
} from '../../../../helpers/purchasing';
import {
  ProductPurchaseDetails,
  ProductPurchasingController,
} from '../../../../types/Purchasing';
import type { ButtonLocation } from '../../../../types/Subscriptions';
import ProductDate from '../../ProductDate';
import { SignUpButton } from '../SignUpButton';
import { toClientUTCDateFormat } from '../utils';

type Props<T extends ProductPurchaseDetails> = {
  buttonLocation?: ButtonLocation;
  buttonSize?: ButtonSizeType;
  product: ProductType;
  purchasingController: ProductPurchasingController<T>;
};

export const PublicSubscriptionCta: React.FC<Props<ProductPurchaseDetails>> = ({
  buttonLocation,
  buttonSize,
  product,
  purchasingController,
}) => {
  const { t } = useTranslation('product');
  const launchDate = new Date(toClientUTCDateFormat(product.launchDate));
  const editionNote = product.editionNote || null;

  return (
    <div className="flex w-full flex-1 flex-col space-y-6">
      <div className="flex w-full flex-1 flex-col">
        <p className="text-center font-bold">
          {isInNextSixDays(launchDate)
            ? t('subscriptionDate.default.countdown')
            : t('subscriptionDate.default.date')}
        </p>
        <p className="text-center">
          <ProductDate date={launchDate} />
        </p>
      </div>

      {editionNote && (
        <div className="flex w-full flex-1 flex-col">
          <p className="text-center text-neutral-4">{editionNote}</p>
        </div>
      )}

      <div className="flex w-full flex-1 flex-col space-y-3">
        <SignUpButton
          buttonLocation={buttonLocation}
          labels={{ normal: t('notifyMe'), success: t('subscribed') }}
          product={product}
          productRef={getProductRef(purchasingController)}
          productStatus={getProductStatus(product, purchasingController)}
          showIcon
          size={buttonSize}
        />
      </div>
    </div>
  );
};
